import isNil from 'lodash/isNil';
import dayjs, {
  Dayjs,
} from 'utils/dayjs';

export type DateTimeIntervalValue = {
  startTime: Dayjs;
  durationInMinutes: number;
};

export const MIN_APPOINTMENT_DATE = dayjs('01/01/1980');
export const MIN_APPOINTMENT_DATE_ERROR_MESSAGE = `Appointment date cannot be earlier than ${MIN_APPOINTMENT_DATE.format('MM/DD/YYYY')}`;

export function toEndTime({
  startTime,
  durationInMinutes,
}: DateTimeIntervalValue): Dayjs {
  return startTime.add(durationInMinutes, 'minute');
}

export function fromStartEnd(start: Dayjs, end: Dayjs): DateTimeIntervalValue {
  return {
    startTime: start,
    durationInMinutes: end.diff(start, 'minute'),
  };
}

export function fromStartAndDuration(
  start: Dayjs | undefined,
  durationInMinutes: number | undefined,
  fallbackStart: Dayjs = dayjs(),
): DateTimeIntervalValue {
  return {
    startTime: start ?? fallbackStart,
    durationInMinutes: durationInMinutes ?? 0,
  };
}

export function validateDateTimeIntervalValue(
  value: DateTimeIntervalValue | null | undefined,
): boolean {
  return !isNil(value)
    && value.startTime.isValid()
    && value.durationInMinutes > 0;
}

export function validateMinAppointmentDateTime(
  value: DateTimeIntervalValue | null | undefined,
): boolean {
  return isNil(value)
    || !value.startTime.isValid()
    || !value.startTime.isBefore(MIN_APPOINTMENT_DATE, 'day');
}
